import { render } from "./ColliBloccatiView.vue?vue&type=template&id=c02d3aac&scoped=true"
import script from "./ColliBloccatiView.vue?vue&type=script&lang=js"
export * from "./ColliBloccatiView.vue?vue&type=script&lang=js"

import "./ColliBloccatiView.vue?vue&type=style&index=0&id=c02d3aac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02d3aac"]])

export default __exports__